(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-before-after"] && !Shopify.designMode) return;
  try {
    
  class BltBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('[data-ba-frame]');
      this.range = this.querySelector('.blt-ba__range');
      if (!this.frame || !this.range) return;

      this.range.addEventListener('input', () => this.#set(this.range.value));

      // Pointer drag anywhere on the frame.
      this.frame.addEventListener('pointerdown', (event) => {
        this.dragging = true;
        this.frame.setPointerCapture?.(event.pointerId);
        this.#fromPointer(event);
      });
      this.frame.addEventListener('pointermove', (event) => {
        if (this.dragging) this.#fromPointer(event);
      });
      const stop = () => { this.dragging = false; };
      this.frame.addEventListener('pointerup', stop);
      this.frame.addEventListener('pointercancel', stop);

      this.#set(this.range.value);
    }

    #fromPointer(event) {
      const rect = this.frame.getBoundingClientRect();
      if (!rect.width) return;
      const pct = ((event.clientX - rect.left) / rect.width) * 100;
      this.#set(pct);
    }

    #set(value) {
      const pct = Math.max(0, Math.min(100, Number(value)));
      this.style.setProperty('--pos', pct + '%');
      if (Number(this.range.value) !== pct) this.range.value = pct;
    }
  }

  if (!customElements.get('blt-before-after')) {
    customElements.define('blt-before-after', BltBeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-product"] && !Shopify.designMode) return;
  try {
    
  /* Self-contained copy of the variant-sync element so this section works on any
     page without depending on the homepage product grid. Guarded so duplicate
     definitions across sections are safe. */
  class CustomCardVariants extends HTMLElement {
    connectedCallback() {
      this.variants = this.#parse('[data-variant-data]') || [];
      this.prices = this.#parse('[data-variant-prices]') || {};
      this.selects = Array.from(this.querySelectorAll('[data-option-position]')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
      this.root = this.closest('.blt-fp') || this.closest('.custom-card');
      this.form = this.closest('form');
      this.selects.forEach((select) => select.addEventListener('change', () => this.#onChange()));
    }

    #parse(selector) {
      const el = this.querySelector(selector);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return null;
      }
    }

    #onChange() {
      const chosen = this.selects.map((select) => select.value);
      const variant = this.variants.find((candidate) => {
        const options = candidate.options || [];
        return chosen.every((value, index) => options[index] === value);
      });
      this.#apply(variant);
    }

    #apply(variant) {
      const idInput = this.form && this.form.querySelector('input[name="id"]');
      const atc = this.form && this.form.querySelector('.custom-card__atc');
      const soldOut = this.form && this.form.querySelector('[data-soldout-text]');
      const priceTarget = this.root && this.root.querySelector('[data-price-target]');
      const compareEl = this.root && this.root.querySelector('[class$="__price-compare"]');
      const available = Boolean(variant && variant.available);

      if (idInput) {
        idInput.value = variant ? variant.id : '';
        idInput.disabled = !available;
      }
      if (atc) atc.disabled = !available;
      if (soldOut) soldOut.hidden = available;

      if (variant && priceTarget) {
        const entry = this.prices[variant.id];
        if (entry) {
          priceTarget.textContent = entry.price;
          if (compareEl) {
            if (entry.compareAt) {
              compareEl.textContent = entry.compareAt;
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
        }
      }
    }
  }

  if (!customElements.get('custom-card-variants')) {
    customElements.define('custom-card-variants', CustomCardVariants);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-grid"] && !Shopify.designMode) return;
  try {
    
  class CustomCardVariants extends HTMLElement {
    connectedCallback() {
      this.variants = this.#parse('[data-variant-data]') || [];
      this.prices = this.#parse('[data-variant-prices]') || {};
      this.selects = Array.from(this.querySelectorAll('.custom-card__option-select')).sort(
        (a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition)
      );
      this.card = this.closest('.custom-card');
      this.form = this.closest('form');
      this.selects.forEach((select) => select.addEventListener('change', () => this.#onChange()));
    }

    #parse(selector) {
      const el = this.querySelector(selector);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        return null;
      }
    }

    #onChange() {
      const chosen = this.selects.map((select) => select.value);
      const variant = this.variants.find((candidate) => {
        const options = candidate.options || [];
        return chosen.every((value, index) => options[index] === value);
      });
      this.#apply(variant);
    }

    #apply(variant) {
      const idInput = this.form && this.form.querySelector('input[name="id"]');
      const atc = this.form && this.form.querySelector('.custom-card__atc');
      const soldOut = this.form && this.form.querySelector('[data-soldout-text]');
      const priceTarget = this.card && this.card.querySelector('[data-price-target]');
      const compareEl = this.card && this.card.querySelector('.custom-card__price-compare');
      const available = Boolean(variant && variant.available);

      if (idInput) {
        idInput.value = variant ? variant.id : '';
        idInput.disabled = !available;
      }
      if (atc) atc.disabled = !available;
      if (soldOut) soldOut.hidden = available;

      if (variant && priceTarget) {
        const entry = this.prices[variant.id];
        if (entry) {
          priceTarget.textContent = entry.price;
          if (compareEl) {
            if (entry.compareAt) {
              compareEl.textContent = entry.compareAt;
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
        }
      }
    }
  }

  if (!customElements.get('custom-card-variants')) {
    customElements.define('custom-card-variants', CustomCardVariants);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  /* Preselect each edit form's country from its saved value (no dependency on
     Shopify's CountryProvinceSelector), and confirm before deleting. */
  document.querySelectorAll('select[data-default-country]').forEach((select) => {
    const value = select.getAttribute('data-default-country');
    if (value) select.value = value;
  });

  document.querySelectorAll('form[data-blt-address-delete]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (!window.confirm('Delete this address?')) event.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  /* If the recover form posted successfully, reveal the recover view so the
     confirmation note is visible (the URL hash is dropped on the reload). */
  (function () {
    if (document.querySelector('[data-recover-success]') && location.hash !== '#recover') {
      location.hash = '#recover';
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
